import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useEramanForgotPassword } from "../Contents.hook";
import { fields } from "../constants";

export const ForgotPassword = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useEramanForgotPassword();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchEditData();
    }
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_register_text: decodeHTML(
        dataById ? dataById.payload.field_register_text : editData ? editData?.[0]?.field_register_text : ""
      ),
      field_key: decodeHTML(dataById ? dataById.payload.field_key : editData ? editData?.[0].field_key : ""),
      field_contine_with_google_text: decodeHTML(
        dataById
          ? dataById.payload.field_contine_with_google_text
          : editData
            ? editData?.[0]?.field_contine_with_google_text
            : ""
      ),
      title: decodeHTML(dataById ? dataById.payload.title : editData ? editData?.[0]?.title : ""),
      field_continue_with_facebook: decodeHTML(
        dataById
          ? dataById.payload.field_continue_with_facebook
          : editData
            ? editData?.[0]?.field_continue_with_facebook
            : ""
      ),
      field_login_text_for_register: decodeHTML(
        dataById
          ? dataById.payload.field_login_text_for_register
          : editData
            ? editData?.[0]?.field_login_text_for_register
            : ""
      ),
      field_email_username_text: decodeHTML(
        dataById ? dataById.payload.field_email_username_text : editData ? editData?.[0]?.field_email_username_text : ""
      ),
      field_eraman_user_text: decodeHTML(
        dataById ? dataById.payload.field_eraman_user_text : editData ? editData?.[0]?.field_eraman_user_text : ""
      ),
      field_password_text: decodeHTML(
        dataById ? dataById.payload.field_password_text : editData ? editData?.[0]?.field_password_text : ""
      ),
      field_forgot_password_text: decodeHTML(
        dataById
          ? dataById.payload.field_forgot_password_text
          : editData
            ? editData?.[0]?.field_forgot_password_text
            : ""
      ),
      field_sign_up_description: decodeHTML(
        dataById ? dataById.payload.field_sign_up_description : editData ? editData?.[0]?.field_sign_up_description : ""
      ),
      field_sign_uptext: decodeHTML(
        dataById ? dataById.payload.field_sign_uptext : editData ? editData?.[0]?.field_sign_uptext : ""
      ),
      field_eye_icon: decodeHTML([
        {
          uid: "-1",
          name: "field_eye_icon.png",
          status: "done",
          url: dataById?.payload?.field_eye_icon?.[0]?.url || editData?.[0]?.field_eye_icon,
        },
      ]),
      field_icon_facebook: decodeHTML([
        {
          uid: "-1",
          name: "field_icon_facebook.png",
          status: "done",
          url: dataById?.payload?.field_icon_facebook?.[0]?.url || editData?.[0]?.field_icon_facebook,
        },
      ]),
      field_icon_image: decodeHTML([
        {
          uid: "-1",
          name: "field_icon_image.png",
          status: "done",
          url: dataById?.payload?.field_icon_image?.[0]?.url || editData?.[0]?.field_icon_image,
        },
      ]),
    },
    fields: fields.eramanForgotPassword,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_icon_image", "field_icon_facebook", "field_eye_icon"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // let descKeys: any = [
    //   "field_sign_up_description",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) {}
    // }

    const payload = {
      action: action,
      method: method,
      module: "Contents",
      subModule: `eramanForgotPassword`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/login-page-crud-api/${editData?.[0]?.id || dataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
